exports.install = function (Vue, options) {
  //var hUrl = "http://yl.api.boaoyiling.com/"; //接口域名
  //var hUrl = "http://hengtong.yl-mall.cn"; //接口域名

  var imgUrl;
  var hUrl;
  initUrl();

  function initUrl() {
    var host = window.location.host;
    if(host.indexOf("hkcfra.cn") != -1) {
      imgUrl = "http://yl.api.boaoyiling.com/";
      hUrl = "http://app.hkcfra.cn/"; //接口域名
    } else if(host.indexOf("yl-mall.cn") != -1) {
      hUrl = "http://hengtong.yl-mall.cn";
      imgUrl = "http://ylst.api.yl-mall.cn/";
    } else {
      imgUrl = "http://localhost:19000";
      //hUrl = "http://hengtong.yl-mall.cn";
    }
  }
  Vue.prototype.call_net = function (typez, url, datas, successFn, errorFn) {
    $.ajax({
      type: typez,
      url: hUrl + url,
      data: datas,
      success: function (msg) {
        successFn(msg)
      },
      error: function (er) {
        errorFn(JSON.parse(er))
      }
    })
  }
  Vue.prototype.external = function (externalName, externalFn) {
    if (!externalName) return
    window[externalName] = externalFn || function () {}
  }

  Vue.prototype.callApp = function (fnName, arg) {
    console.log('调用原生方法：', fnName + "('" + arg + "')")
    fnName = fnName || ''
    arg = arg || []
    window.location.href = 'javascript:window.Android.' + fnName + "('" + arg + "')"
  }

  Vue.prototype.getUrlParamURLys = function (name) {
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = null
    if (decodeURIComponent(window.location.href).indexOf(name) > -1) {
      r = decodeURIComponent(window.location.href).split(name+'=')[1].split('&')[0]
    }
    if (r!=null){
      return r;
    }
    return false; //返回参数值
  }
  Vue.prototype.hUrl = function () {
    return "http://mm.yl-mall.cn"; //返回参数值
  }

}



// WEBPACK FOOTER //
// ./src/base.js